// Вспомогательная функция include для шаблонизатора Handlebars, позволяющая вставлять паршелы с параметрами
Handlebars.registerHelper('include', function(template, options) {
	if (options && options.hash && options.hash.data) {
		var data = options.hash.data;

		delete (options.hash.data);

		for (var key in options.hash) {
			if (typeof options.hash[key] === 'string') {
				options.hash[key] = Handlebars.compile(options.hash[key])(data);
			}
		}
	}

	return new Handlebars.SafeString((Handlebars.partials[template])($.extend({}, this === window ? {} : this, options.hash)));
});

// Вспомогательная функция stripes, позволяющая выделять четные и нечетные элементы
Handlebars.registerHelper('stripes', function(array, even, odd, fn, elseFn) {
	if (array && array.length > 0) {
		var buffer = '';

		for (var i = 0, max = array.length; i < max; i++) {
			var item = array[i];

			item.stripeClass = (i % 2 == 0 ? even : odd);
			buffer += fn(item);
		}
		return buffer;
	} else {
		return elseFn();
	}
});

// Вспомогательная функция eq, проверяющая аргументы на равенство
Handlebars.registerHelper('eq', function(val, val2, block) {
	if (val == val2) {
		return block(this);
	}
	return '';
});

// Вспомогательная функция empty, проверяющая условие на пустоту
Handlebars.registerHelper('empty', function(context, options) {
	var type = toString.call(context);

	if (type === functionType) {
		context = context.call(this);
	}

	if (!$.trim(context) || Handlebars.Utils.isEmpty(context)) {
		return options.inverse(this);
	} else {
		return options.fn(this);
	}
});

Handlebars.registerHelper('if_num', function(context, options) {
	var type = toString.call(context);

	if (type === functionType) {
		context = context.call(this);
	}

	type = toString.call(context);

	if (type === '[object Number]') {
		context = context.toString();
	}

	if(!context || Handlebars.Utils.isEmpty(context)) {
		return options.inverse(this);
	} else {
		return options.fn(this);
	}
});

// Вспомогательная функция для формирования классов для js на основании имен полей форм
Handlebars.registerHelper('jsname', function(value) {
	return value.replace(/\.|\[|\]/g, '').toLowerCase();
});

// Вспомогательная функция trim
Handlebars.registerHelper('trim', function(value) {
	return $.trim(value);
});

// Вспомогательная функция or, аналог оператора "||"
Handlebars.registerHelper('or', function() {
	var max = arguments.length - 1,
		options = arguments[max];

	for (var i = 0; i < max; i++) {
		if (arguments[i]) {
			return options.fn(this);
		}
	}

	return options.inverse(this);
});

Handlebars.registerHelper('if_all', function() {
	var max = arguments.length - 1,
		options = arguments[max];

	for (var i = 0; i < max; i++) {
		if (!arguments[i]) {
			return options.inverse(this)
		}
	}

	return options.fn(this);
});

Handlebars.registerHelper('unless_all', function() {
	var max = arguments.length - 1,
		options = arguments[max];

	for (var i = 0; i < max; i++) {
		if (arguments[i]) {
			return options.inverse(this)
		}
	}

	return options.fn(this);
});

// Вспомогательная функция capitalize
Handlebars.registerHelper('capitalize', function(value) {
	return value.charAt(0).toUpperCase() + value.substr(1);
});

Handlebars.registerHelper('loading', function () {
	return new Handlebars.SafeString('<span class="g-dot g-dot--first">.</span>' +
		'<span class="g-dot g-dot--second">.</span><span class="g-dot g-dot--third">.</span>');
});

Handlebars.registerHelper('any', function () {
	var array = arguments[0],
		options = arguments[arguments.length - 1],
		fieldNamesLength = arguments.length - 2,
		fieldNames;

	if (fieldNamesLength > 0) {
		fieldNames = Array.prototype.slice.call(arguments, 1, arguments.length - 1);

		var acceptedItem = _.find(array, function (item) {
				for (var i = 0, imax = fieldNames.length; i < imax; i++) {
					if (!item[fieldNames[i]]) {
						return false;
					}
				}

				return true;
			});

		if (acceptedItem) {
			return options.fn(this);
		} else {
			return options.inverse(this);
		}
	} else if (_.any(array)) {
		return options.fn(this);
	} else {
		return options.inverse(this);
	}
});

Handlebars.registerHelper('pluralNumber', function (count, arg0, arg1, arg2, arg3) {
	return Common.pluralNumber(count, arg0, arg1, arg2, arg3);
});

(function () {
	var MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

	function createDisplayDate (date) {
		return date ? date.split('T')[0].split('-').reverse().join('.') : date;
	}

	function createDisplayDateLocalized (date) {
		if (!date) {
			return date;
		}

		var dateArr = date.split('T')[0].split('-');

		dateArr[1] = MONTHS[dateArr[1] - 1];
		

		return dateArr.reverse().join(' ');
	}

	function createDisplayTime (date) {
		if (!date) {
			return date;
		}

		var timeArr = date.split('T')[1].split(':').splice(0, 2);

		timeArr[0] = parseInt(timeArr[0], 10).toString();

		if (timeArr[1].length < 2) {
			timeArr[1] = '0' + timeArr[1];
		}

		return timeArr.join(':');
	}

	Handlebars.registerHelper('displayDate', createDisplayDate);

	Handlebars.registerHelper('createDisplayDateLocalized', createDisplayDateLocalized);

	Handlebars.registerHelper('displayDateTime', function (date) {
		return date ? createDisplayDate(date) + ' ' + createDisplayTime(date) : date;
	});

	Handlebars.registerHelper('displayDateTimeLocalized', function (date) {
		return date ? createDisplayDateLocalized(date) + ' ' + createDisplayTime(date) : date;
	});
})();
